/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var windowWidth = $(window).width(),
      isSmallDevice = windowWidth < 800 ? true : false,
      isMobileDevice = windowWidth < 481 ? true : false;

  $(document).ready(function(){
    SetupNavDrawerMobile();
    $('.menu__item.parent > a').each(function(){
      SetupNavMenuDesktop($(this));
    });

    $(document).on("click", ".modal--is-visible .drawer__overlay", function(){
      CloseOpenedNavMenu();
    });

    SetupSearchToggle();
    setTimeout(function() { SetupVariantSelector(); }, 20);
    SetupCookieHandler();
    SetupCartItemNumberTracking();
    if (isSmallDevice) {
      HandleQuickBuyOnTouch();
    }

    if($('body').hasClass("template-blog") || $('body').hasClass("template-article")){
      SetupBlogMenu();
    }
    if($('body').attr("id") == 'production' || $('body').attr("id") == 'production-mobile'){
      RedirectToCorrepondingMobilePage();
      SetupProductionPageElements();
    }
    if($('body').attr("id") == 'baserange-stores' || $('body').attr("id") == 'boutiques-baserange'){
      HandleStoresPageMenu();
    }
    if ($("body#baserange-contact").length) {
      SetupContactForm();
    }
    if($('body').attr("id") == 'collections'){
      window.location.href = "/collections/new-arrivals";
    }

    if($('body').hasClass("template-cart")){
      window.location.href = "/";
    }


    //External Resources
    SetupShogunTrigger();
  });

  function SetupNavMenuDesktop($navItem) {
    $navItem.click(function(event){
      event.preventDefault();
      //Hide other open menu if they are open
      $menuActive = $(this).parent().parent().siblings(".menu__items").first().find(".is-visible");
      if($menuActive.length){
        $menuActive.toggleClass("is-visible");
      }
      //Hide/Show current menu
      $(this).parent().toggleClass("is-visible");

      //Hide/Show an overlay to the website
      if ($(".menu__items .is-visible").length) {
        if (!$("body.modal--is-visible").length) { $("body").addClass("modal--is-visible"); }
      } else {
        $("body.modal--is-visible").removeClass('modal--is-visible');
      }
    });
  }
  function CloseOpenedNavMenu() {
    $('.menu__item.is-visible').removeClass("is-visible");
    $('body.modal--is-visible').removeClass("modal--is-visible");
  }

  function SetupNavDrawerMobile() {
    //Open drawer
    $('.js-drawer-open-custom').click(function(){
      $('body').addClass('js-drawer-open');
      $('#NavDrawerCustom').addClass('is-open');
    });
    $('.js-drawer-open-bis').click(function(){
      $('body').addClass('js-drawer-open');
      $('#NavDrawerBis').addClass('is-open');
    });
    //Close drawer
    $(".drawer__close").click(function(){
      $(this).closest(".is-open").removeClass("is-open");
      $('body').removeClass('js-drawer-open');
    });
    if($('#NavDrawerCustom .mobile-nav__toggle').length) {
      $('#NavDrawerCustom .mobile-nav__has-sublist').each(function(){
        $(this).click(function(e){
          e.preventDefault();
          if($(this).hasClass("mobile-nav--expanded")) {
            $(this).removeClass("mobile-nav--expanded");
          } else {
            if($("#NavDrawerCustom .mobile-nav--expanded").length) {
              $("#NavDrawerCustom .mobile-nav--expanded").removeClass("mobile-nav--expanded");
            }
            $(this).addClass("mobile-nav--expanded");
          }
        });
      });
    }
  }

  function SetupSearchToggle() {
    $('.menu__item.menu__item--icons .search-popdown__toggle').click(function(){
      $('h1.logo').hide();
      CloseOpenedNavMenu();
      var inputField = document.querySelector("#searchInput-desktop"); 
      inputField.value = "";
      inputField.dispatchEvent(new Event("input"));
      console.log("SetupSearchToggle trigger");
      setTimeout(function() { $('#searchInput-desktop')[0].focus(); }, 12);
    });

    $('.customNavDrawer .search-popdown__toggle').click(function(){
      $('#searchInput-desktop-compress').val("");
      setTimeout(function() { $('#searchInput-desktop-compress')[0].focus(); }, 12);
    });
    $('.customNavDrawer .mobile-search-label').click(function(){
      let summary = $(this).prev().find("summary");
      summary.trigger("click");
    });

    $('.search-popdown__close').click(function(){
      $('h1.logo').show();
    });
    $(document).on("click", '.search-opened .main-content', function(){
      $('h1.logo').show();
    });
    $(document).keyup(function(e) {
      if (e.key === "Escape") { // escape key maps to keycode `27`
        if ($('.search-opened').length) { $('h1.logo').show(); }
      }
    });
  }

  function SetupVariantSelector() {
    //Global behaviour for custom product variant selector
    if($(".product-single__details .custom-selector-container").length || $('.btn--quick').length) {

      //Open one custom selector list at time
      $(document).on( "click", '.custom-selector-container', function(){
        var $this = $(this).children().first();
        $(".custom-selector-inner.open").each(function(){
          //On compare les éléments HTML -> Si on utilise directement les objets JS, les contextes sont différents et ne sont donc pas égaux.
          if($(this)[0] != $this[0]) { $(this).removeClass("open"); }
        });
        this.querySelector('.custom-selector-inner').classList.toggle('open');
      });

      //Close custom selector list if user click anywhere on page
      window.addEventListener('click', function(e) {
        if ($('.custom-selector-container.open').length){
          const select = document.querySelector('.custom-selector-container.open');
          if (!select.contains(e.target)) { select.classList.remove('open'); }
        }
      });
    }

    //Product behaviour
    if($(".product-single__details .custom-selector-container").length) {
      //Confirm option choiced in custom selector list
      for (const option of document.querySelectorAll(".product-single__details .custom-selector__option")) {
        option.addEventListener('click', function() {
          
          //Size process
          if ($(this).closest(".related-size-form").length) {
            let sizeRadioInput = $(this).closest(".custom-size-selector").next().find(".radio__input");
            sizeRadioInput.each(function() { $(this).removeAttr("checked") });

            let optionValue = $(this).data("value");
            let optionMatch = $(this).closest(".custom-size-selector").next().find('.radio__input[value="'+optionValue+'"]');
            optionMatch.attr('checked', true).trigger('click').trigger('change');
            $(this).closest('form.product__form').trigger('change');

            //Out of stock process
            let isOOS = $(this).hasClass("sold-out") ? true : false;
            if (isOOS) {
              let newText = optionValue+" Notify Me When Re-Stocked"
              $('.product__submit__item button').text("Unavailable").prop("disabled", "disabled");
            } else {
              $('.product__submit__item button').text("Add to Cart").removeProp("disabled");
            }
          }

          //Amount process (for gift cards)
          if ($(this).closest(".related-amount-form").length) {
            let amountRadioInput = $(this).closest(".custom-amount-selector").next().find(".radio__input");
            amountRadioInput.each(function() { $(this).removeAttr("checked") });

            let optionValue = $(this).data("value");
            let optionMatch = $(this).closest(".custom-amount-selector").next().find('.radio__input[value="'+optionValue+'"]');
            optionMatch.attr('checked', true).trigger('click').trigger('change');
            $(this).closest('form.product__form').trigger('change');
          }

          if (!this.classList.contains('selected')) {
            if($(this).parent().find('.custom-selector__option.selected').length) { this.parentNode.querySelector('.custom-selector__option.selected').classList.remove('selected'); }
            this.classList.add('selected');
          }
          let newText = $(this).text();
          $(this).closest('.custom-selector-container').find('.custom-selector__selected-value').text(newText);

          //Color process
          if ($(this).closest(".related-color-form").length) {
            let currentLocale = ExtractLocaleInString(window.location.href);
            let testedLocal = ExtractLocaleInString($(this).data("url"));
            let url = $(this).data("url");
            if (currentLocale && $(this).data("url") && $(this).data("url") != "#" && currentLocale != testedLocal) {
              if (testedLocal) {
                let strToReplace = "baserange.com/"+testedLocal;
                url = $(this).data("url").replace(strToReplace, "baserange.com/"+currentLocale);
              } else {
                url = "/" + currentLocale + url;
              }
            }
            window.location.href = url;
          }
        });
      }
    }

    //Quick-buy behaviour (slightly different)
    if($('.btn--quick').length || $(".product-single__details .custom-selector-container").length) {
      //Confirm option choiced in custom selector list
      $(document).on( "click", '.popup-quick-view__body .custom-selector__option', function(){

        //Size process
        if ($(this).closest(".related-size-form").length) {
          let sizeRadioInput = $(this).closest(".custom-size-selector").next().find(".radio__input");
          sizeRadioInput.each(function() { $(this).removeAttr("checked") });

          let optionValue = $(this).data("value");
          let optionMatch = $(this).closest(".custom-size-selector").next().find('.radio__input[value="'+optionValue+'"]');
          optionMatch.attr('checked', true).trigger('click').trigger('change');
          $(this).closest('form.product__form').trigger('change');

          //Out of stock process
          let isOOS = $(this).hasClass("sold-out") ? true : false;
          if (isOOS) {
            let newText = optionValue+" Notify Me When Re-Stocked"
            $('.product__submit__item button').text("Unavailable").prop("disabled", "disabled");
          } else {
            $('.product__submit__item button').text("Add to Cart").removeProp("disabled");
          }
        }

        //Amount process (for gift cards)
        if ($(this).closest(".related-amount-form").length) {
          let amountRadioInput = $(this).closest(".custom-amount-selector").next().find(".radio__input");
          amountRadioInput.each(function() { $(this).removeAttr("checked") });

          let optionValue = $(this).data("value");
          let optionMatch = $(this).closest(".custom-amount-selector").next().find('.radio__input[value="'+optionValue+'"]');
          optionMatch.attr('checked', true).trigger('click').trigger('change');
          $(this).closest('form.product__form').trigger('change');

          //Out of stock process
          let isOOS = $(this).hasClass("sold-out") ? true : false;
          if (isOOS) {
            let newText = optionValue+" Notify Me When Re-Stocked"
            $('.product__submit__item button').text("Unavailable").prop("disabled", "disabled");
          } else {
            $('.product__submit__item button').text("Add to Cart").removeProp("disabled");
          }
        }

        if (!$(this).hasClass('selected')) {
          if($(this).parent().find('.custom-selector__option.selected').length) { $(this).parent().find('.custom-selector__option.selected').removeClass('selected'); }
          $(this).addClass('selected');
        }
        let newText = $(this).text();
        $(this).closest('.custom-selector-container').find('.custom-selector__selected-value').text(newText);
        
        //Color process
        if ($(this).closest(".related-color-form").length) {
          let currentLocale = ExtractLocaleInString(window.location.href);
          let testedLocal = ExtractLocaleInString($(this).data("url"));
          let url = $(this).data("url");

          if (currentLocale && $(this).data("url") && $(this).data("url") != "#" && currentLocale != testedLocal) {
            if (testedLocal) {
              let strToReplace = "baserange.com/"+testedLocal;
              url = $(this).data("url").replace(strToReplace, "baserange.com/"+currentLocale);
            } else {
              url = "/" + currentLocale + url;
            }
          }

          window.location.href = url;
        } 
      });

      //Fix the img height difference between featured media and slider img induced by theme
      // $('.product-grid-item').hover(function(){
      //   if($(this).hasClass("imgFixed")) { return true; } //Add a marker to skip the process (only do it once)
      //   let $featuredImg = $(this).find(".product-single__media-slide img"),
      //       $featuredImgHeight = $featuredImg.outerHeight(),
      //       $sliderImgs = $(this).find('.product__media__slide img'),
      //       $productImgGap = $sliderImgs.outerHeight() - $featuredImgHeight;

      //   console.log($featuredImgHeight);
      //   console.log($sliderImgs.outerHeight());
      //   console.log($productImgGap);

      //   $sliderImgs.each(function(){
      //     $(this).css({
      //       "min-height" : 1,
      //       "height": $featuredImgHeight
      //     });
      //   });

      //   $(this).addClass("imgFixed");
      // });
    }
  }

  function SetupCookieHandler(){
    $cookiesFooterLink = $('#FooterMenu--information-2 > ul:nth-child(1) > li:nth-child(5) > a:nth-child(1)');
    $cookiesFooterLink.click(function(){
      $('.otCookiesNotification > div').trigger("click");
    });
  }

  function HandleQuickBuyOnTouch() {
    $(document).on("touchstart", ".product-grid-item", function(e){
      if(!$(this).hasClass("quick-buy-mobile-init")) {
        $('.quick-buy-mobile-init').removeClass("quick-buy-mobile-init");
        $(this).addClass("quick-buy-mobile-init");
      }
    });
  }

  function SetupCartItemNumberTracking() {
    var $cartItemNumber = $('.cart_item_tracking');

    //Adjust Qty based on the AddToCart btn and the Quick Buy
    $(document).on('click', '.product__submit__add', function(){
      let currentCartItemNumber = parseInt($cartItemNumber.text()) + 1;
      $cartItemNumber.text(currentCartItemNumber);
    });
    //Adjust Qty based on +/- button in the ajax cart
    $(document).on('click', '.cart__item__quantity', function(e){
      e.preventDefault();
      let currentCartItemNumber = parseInt($cartItemNumber.text());
      let $target = $(e.target);
      if($target.hasClass('cart__item__quantity-minus') || $target.hasClass('icon-toggle-minus')){
        currentCartItemNumber = currentCartItemNumber - 1;
      }
      if($target.hasClass('cart__item__quantity-plus') || $target.hasClass('icon-toggle-plus')){
        currentCartItemNumber = currentCartItemNumber + 1;
      }
      $cartItemNumber.text(currentCartItemNumber);
    });
    //Adjust Qty based on the Remove button in the ajax cart
    $(document).on('click', '.cart__item__remove', function(){
      let currentItemQty = $(this).parent().parent().find(".cart__item__quantity-field").val();
      let currentCartItemNumber = parseInt($cartItemNumber.text()) - currentItemQty;
      $cartItemNumber.text(currentCartItemNumber);
      console.log(currentItemQty);
    });
  }

  function SetupBlogMenu() {
    let widthElement = $(".pgi.grid__item").first().width();
    $(".category-filter-menu li").width(widthElement);
    $(window).on('resize', function(){
      let newWidthElement = $(".pgi.grid__item").first().width();
      $(".category-filter-menu li").width(newWidthElement);
    });

    $(document).on('click', '.blog-menu-control .show-more-blog-menu-link, .blog-menu-control .show-less-blog-menu-link', function(e){
      e.preventDefault();
      ProcessBlogMenu("desktop");
    });
    $(document).on('click', '.blog-menu-control-mobile .show-more-blog-menu-link, .blog-menu-control-mobile .show-less-blog-menu-link', function(e){
      e.preventDefault();
      ProcessBlogMenu("mobile");
    });
  }

  // Page Blog
  function ProcessBlogMenu(mode){
    $('.show-more-blog-menu-link').toggle();
    $('.show-less-blog-menu-link').toggle();
    if(mode == "desktop") {
      var nbLi = $('ul.category-filter-menu:nth-child(2) li').length;
      var nbTodisplay = Math.ceil( (nbLi - 9) / 3);
      var newHeight = nbTodisplay * 26;
      $('ul.category-filter-menu:nth-child(2)').css("max-height", newHeight+"px");
      $('ul.category-filter-menu:nth-child(2)').toggleClass("category-filter-menu-open");
      $('header.section-header').toggleClass("blog-menu-open");
    } else {
      $('ul.category-filter-menu:nth-child(1) li:nth-child(n+7)').toggle();
    }
  }

  //Page Contact
  function SetupContactForm() {
    $('.shogun-form-dropdown select').change(function(){
      if ($(this).val() == "Returns & Exchanges" || $(this).val() == "Order Payment" || $(this).val() == "Shipping tracking") {
        if(!$(".contact-form-order-number").length) {
          var orderNumberField  = '<div id="s-403a2bda-86ac-4511-9dd7-cb4d20323cc4" class="shg-c contact-form-order-number">';
              orderNumberField +=  '<div class="shogun-form-text-input" data-field-type="text">';
              orderNumberField +=    '<label class="shogun-form-label">Country</label>';
              orderNumberField +=    '<input id="input-s-403a2bda-86ac-4511-9dd7-cb4d20323cc4" class="shogun-form-box-field shogun-form-text-input-field" name="Order_Number" placeholder="Order Number" type="text" required="true">';
              orderNumberField +=    '<div class="shogun-form-field-error-msg-container">';
              orderNumberField +=      '<div class="shogun-form-field-error-msg">';
              orderNumberField +=        '<svg viewBox="0 0 26 26" width="16px" height="16px">';
              orderNumberField +=          '<path d="M13 1c6.627 0 12 5.373 12 12s-5.373 12-12 12S1 19.627 1 13 6.373 1 13 1zm0 1.5C7.201 2.5 2.5 7.201 2.5 13S7.201 23.5 13 23.5 23.5 18.799 23.5 13 18.799 2.5 13 2.5zm0 14.25l.123.007a1.125 1.125 0 11-.246 0L13 16.75zM13 5.5a.75.75 0 01.743.648l.007.102v8.25a.75.75 0 01-1.493.102l-.007-.102V6.25A.75.75 0 0113 5.5z" fill="currentColor" fillrule="nonzero"></path>';
              orderNumberField +=        '</svg>';
              orderNumberField +=        '<span>Value is required</span>';
              orderNumberField +=      '</div>';
              orderNumberField +=    '</div>';
              orderNumberField +=  '</div>';
              orderNumberField += '</div>';

          $(orderNumberField).insertAfter($(this).parent().parent());
        }
      } else {
        if($(".contact-form-order-number").length) {
          $(".contact-form-order-number").remove();
        }
      }
    });
  }

  //Page Stores
  function HandleStoresPageMenu() {
    var $copenhagenHtmlAnchor = $("#s-5f9c9c57-fea6-4850-a169-0022f757a4d0"),
        $copenhagenMenuLink = $(".page-menu:nth-child(1) > li:nth-child(1) > a"),
        $tokyoHtmlAnchor = $("#s-bc5e4249-45c8-467f-aa0f-16909e3e68d0"),
        $tokyoMenuLink = $(".page-menu:nth-child(1) > li:nth-child(2) > a"),
        $kyotoHtmlAnchor = $("#s-6c0719fc-81d4-4da0-9e4e-28a983e964aa"),
        $kyotoMenuLink = $(".page-menu:nth-child(1) > li:nth-child(3) > a"),
        $MelbourneHtmlAnchor = $("#s-2a0a3af8-172b-45f9-a886-07769cec614e"),
        $MelbourneMenuLink = $(".page-menu:nth-child(2) > li:nth-child(1) > a"),
        $seoulHtmlAnchor = $("#s-f8827981-dfc5-4efa-b0ba-c294db76323f"),
        $seoulMenuLink = $(".page-menu:nth-child(2) > li:nth-child(2) > a"),
        $shinsegaeGangnamHtmlAnchor = $("#s-d7a946a4-e0f0-4a6e-8321-25736c7db78a"),
        $shinsegaeGangnamMenuLink = $(".page-menu:nth-child(2) > li:nth-child(3) > a");

    $copenhagenMenuLink.click(function(e){
      e.preventDefault();
      window.scrollTo(0, 0);
      return false;
    });
    $tokyoMenuLink.click(function(e){
      e.preventDefault();
      $tokyoHtmlAnchor[0].scrollIntoView();
      return false;
    });
    $kyotoMenuLink.click(function(e){
      e.preventDefault();
      $kyotoHtmlAnchor[0].scrollIntoView();
      return false;
    });
    $MelbourneMenuLink.click(function(e){
      e.preventDefault();
      $MelbourneHtmlAnchor[0].scrollIntoView();
      return false;
    });
    $seoulMenuLink.click(function(e){
      e.preventDefault();
      $seoulHtmlAnchor[0].scrollIntoView();
      return false;
    });
    $shinsegaeGangnamMenuLink.click(function(e){
      e.preventDefault();
      $shinsegaeGangnamHtmlAnchor[0].scrollIntoView();
      return false;
    });

    $(window).scroll(function(){
      if($copenhagenHtmlAnchor.isInViewport()) {
        if(!$copenhagenMenuLink.hasClass("page-menu-active")) {
          $(".page-menu-active").removeClass("page-menu-active");
          $copenhagenMenuLink.addClass("page-menu-active");
        }
      } else if($tokyoHtmlAnchor.isInViewport()) {
        if(!$tokyoMenuLink.hasClass("page-menu-active")) {
          $(".page-menu-active").removeClass("page-menu-active");
          $tokyoMenuLink.addClass("page-menu-active");
        }
      } else if($kyotoHtmlAnchor.isInViewport()) {
        if(!$kyotoMenuLink.hasClass("page-menu-active")) {
          $(".page-menu-active").removeClass("page-menu-active");
          $kyotoMenuLink.addClass("page-menu-active");
        }
      } else if($MelbourneHtmlAnchor.isInViewport()) {
        if(!$MelbourneMenuLink.hasClass("page-menu-active")) {
          $(".page-menu-active").removeClass("page-menu-active");
          $MelbourneMenuLink.addClass("page-menu-active");
        }
      } else if($seoulHtmlAnchor.isInViewport()) {
        if(!$seoulMenuLink.hasClass("page-menu-active")) {
          $(".page-menu-active").removeClass("page-menu-active");
          $seoulMenuLink.addClass("page-menu-active");
        }
      } else if($shinsegaeGangnamHtmlAnchor.isInViewport()) {
        if(!$shinsegaeGangnamMenuLink.hasClass("page-menu-active")) {
          $(".page-menu-active").removeClass("page-menu-active");
          $shinsegaeGangnamMenuLink.addClass("page-menu-active");
        }
      }
    });
  }

  //Page Production
  function RedirectToCorrepondingMobilePage() {
    let pageUrl = window.location.href;
    if(pageUrl[pageUrl.length -1] == "/") {
      pageUrl = pageUrl.substr(pageUrl.length - 1);
    }
    let isMobile = navigator.userAgent.match(/(iPhone|iPo@d|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
    if(isMobile && pageUrl.indexOf("productionmobile") == -1) {
      window.location.replace(pageUrl+"mobile");
    }
  }
  function SetupProductionPageElements(){
    var $menuElements = [];
    $('.page-production-menu').each(function(ul) {
      $(this).children().each(function(li) {
        $menuElements.push($(this));
      })
    });

    $(window).scroll(function(){
      $.each($menuElements, function(i, $li){
        let $link = $($li[0]).find("a");
        let idToUse = $link.attr("href").split("#").pop();
        let $el = $("#" + idToUse);
        if($el.isInViewport()) {
          if(!$link.hasClass("page-menu-active")) {
            $(".page-menu-active").removeClass("page-menu-active");
            $link.addClass("page-menu-active");
          }
        }
      });
    });
  }

  //Third Party
  function SetupShogunTrigger() {
    $(document).on('submit','form.search-bar',function(){
      gtag('event','recherche',{'event_category':'engagement','event_label':''});
    });
    $(document).on('submit','form.klaviyo-form-version-cid_1',function(){
     gtag('event','inscription_newsletter',{'event_category':'prospect','event_label':'footer'});
    });
    $(document).on('submit','form.klaviyo-form-version-cid_3',function(){
     gtag('event','inscription_newsletter',{'event_category':'prospect','event_label':'popup'});
    });
    $(document).on('submit','form.shogun-form-box',function(){
     gtag('event','envoi_formulaire_contact',{'event_category':'prospect','event_label':''});
    });
    $(document).on('click','.klaviyo-close-form',function(){
      gtag('event','fermeture_newsletter',{'event_category':'engagement','event_label':'pop_up'});
    });
    $(document).on('click','#Tokyo',function(){
      gtag('event','clic_instagram',{'event_category':'engagement','event_label':'Tokyo'});
    });
    $(document).on('click','#Kyoto',function(){
      gtag('event','clic_instagram',{'event_category':'engagement','event_label':'Kyoto'});
    });
    $(document).on('click','#Seoul',function(){
      gtag('event','clic_instagram',{'event_category':'engagement','event_label':'Seoul'});
    });
    $(document).on('click','#Melbourne',function(){
      gtag('event','clic_instagram',{'event_category':'engagement','event_label':'Melbourne'});
    });
    $(document).on('click','#baserange-stockists .shogun-root a',function(e){
      var txt = $(e.target).text();
      gtag('event','clic_lien_sortant',{'event_category':'prospect','event_label':txt});
    });
  }
  
  /**
   * Get the current Local in a string
   * @param {String} - The string to parse
   * @Return {String} - locale code if it found, else return false
   */
  function ExtractLocaleInString(str){
    var result = false;
    var locales = [
      "en",
      "fr",
      "de",
      "ja",
      "ko",
      "zh",
      "en-us",
      "fr-us",
      "de-us",
      "ja-us",
      "ko-us",
      "zh-us",
      "en-jp",
      "fr-jp",
      "de-jp",
      "ja-jp",
      "ko-jp",
      "zh-jp",
      "en-kr",
      "fr-kr",
      "de-kr",
      "ja-kr",
      "ko-kr",
      "zh-kr",
      "en-cn",
      "fr-cn",
      "de-cn",
      "ja-cn",
      "ko-cn",
      "zh-cn"
    ];
    for (var i = 0; i < locales.length; i++) {
      let pattern1 = new RegExp('\/'+locales[i]+'$');
      let pattern2 = new RegExp('\/'+locales[i]+'\/');
      if (str.match(pattern1) || str.match(pattern2)) {
        result = locales[i];
        break;
      }
    }
    return result;
  }

  /**
   * Check if the target element is int the viewport of the navigator
   * @return {Bool} - True if taget is in viewport, else False
   */
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
